import React, { useEffect, useRef, useState } from "react";

import {
  Modal,
  Box,
  Typography,
  Autocomplete,
  Backdrop,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";

import CloseIcon from "@mui/icons-material/Close";
import { Btn } from "../../../../AbstractElements";

import ConfirmModal from "../../../CGITrackingNew/ConfirmModal";
import { Col, Row } from "reactstrap";
import { useAuth } from "oidc-react";
import { getUserRole, ShowError } from "../../../../_helper/helper";

const AnnouncementStatusChangeModal = ({
  isOpen,
  currentStatus,
  processStatusList,
  overallRating,
  setFieldValue,
  handleClose,
  handleSubmit,
  newState,
  oldState,
  AnnouncementStatus,
  AnnouncementStatusChanged,
  onNewStatusSelected,
}) => {
  const [status, setStatus] = useState("Approve");
  const [remarks, setRemarks] = useState("");
  const remarkRef = useRef();
  const [openConfirmation, setOpenConfirmation] = useState(false);

  const [currentProcessTitle, setCurrentProcessTitle] = useState("");
  const [returnState, setReturnState] = useState();
  const [forwardState, setForwardState] = useState();
  const [change, setChange] = useState(true);

  const user = sessionStorage.getItem("currentRole");
  const reviewer = "REVIEWER";
  const employee = "user";
  const supervisor = "SUPERVISOR";
  const supervisor_admin = "SUPERVISOR-ADMIN";
  const supervisor_non_admin = "SUPERVISOR-NON-ADMIN";
  const [approve, setApprove] = useState(false);

  const { userData } = useAuth();
  const role = getUserRole(userData);

  useEffect(() => {
    if (processStatusList && processStatusList.length) {
      const newData = [...processStatusList]
        .sort((a, b) => Number(a?.seq || 0) - Number(b?.seq || 0))
        .filter((item) => item.statusName !== "Submitted");
      const currentProcess = newData.find((item) => item?.id == currentStatus);
      if (AnnouncementStatusChanged && AnnouncementStatus && AnnouncementStatus != "" &&
        (AnnouncementStatus == "Amendment" || AnnouncementStatus == "Cancel" || AnnouncementStatus == "Close")
        && currentProcess?.statusName != "Appointing Authority") {
        setCurrentProcessTitle(currentProcess?.statusName);
        const isNext = newData.find((i) => i.statusName == "Appointing Authority");
        setForwardState({ label: isNext?.statusName, value: isNext?.id });
        setReturnState(null);
      } else {
        if (currentProcess) {
          setCurrentProcessTitle(currentProcess.statusName);
          const currentIndex = newData.findIndex((item) => item?.id == currentStatus);
          const nextState = currentIndex > -1
            ? (newData[currentIndex + 1] || newData[currentIndex])
            : null;

          setForwardState(
            nextState
              ? { label: nextState?.statusName, value: nextState?.id }
              : null
          );

          if (currentIndex > 0) {
            let returnIndex = currentIndex - 1;
            if (currentProcess?.statusName == "Closed" && currentIndex > 1) {
              returnIndex = currentIndex - 2;
            }
            const prevState = newData[returnIndex];
            setReturnState(
              prevState
                ? { label: prevState?.statusName, value: prevState?.id }
                : null
            );
          } else {
            setReturnState(null);
          }
        }
      }
    }
  }, [processStatusList, currentStatus, newState, oldState, AnnouncementStatus, AnnouncementStatusChanged]);



  const handleModleSubmit = () => {
    // debugger
    // console.log("sdafsdafsdfsdfsdfsad modal",currentStatus, approve, role)
    // if (currentStatus == 353 &&
    //   role != "AppointingAurhority" &&
    //   approve
    // ) {
    //   ShowError("You are not authorized to post the Announcement.");
    //   return false;
    // }

    setOpenConfirmation(true);
  };


  const onConfirm = () => {

    console.log("12121212 ::: ", approve, status)

    if (status == "Return") {
      setFieldValue("transactionstatus", "Return");
      setFieldValue("AnnouncementStatus", "")
      if (returnState?.value == 353) {
        setFieldValue("status", "CLOSED");
      }
    }

    if (approve || status == "Approve") {
      setFieldValue("transactionstatus", "Approved");
      if (forwardState?.value == 386) {
        setFieldValue("AnnouncementStatus", "Close")
        setFieldValue("status", "CLOSED");
      }
      // props.setFieldValue("CurrentProcessStatus", nextStatus);
      //   if (props?.errorMsgs?.length == 0) {
      //     props?.setLocalCurrentStatus(props?.currentStatus);
      //     if (props?.noa == "30" || props?.noa == "58") {
      //       if (props?.uploadedDocuments?.length > 0) {
      //         props.setFieldValue("CurrentProcessStatus", forwardState);
      //       }
      //     } else {
      //       props.setFieldValue("CurrentProcessStatus", forwardState);
      //     }
      //   }
      onNewStatusSelected?.(forwardState?.value);
      //   props.setStatusRemark(remarks);
      //   props.setProcessStatusChanged(true);
      handleClose();
    } else {
      if (remarks != "") {
        onNewStatusSelected?.(returnState?.value);
        // props.setStatusRemark(remarks);
        // props.setProcessStatusChanged(true);
        handleClose();
      }
    }
    setRemarks("");
    setStatus("Approve");
    handleClose();
    setOpenConfirmation(!openConfirmation);
    setFieldValue("isSave", false);
    handleSubmit();
  };

  return (
    <div>
      <Dialog open={isOpen} onClose={handleClose} fullWidth>
        <DialogTitle>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            Current Status: {currentProcessTitle}
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent>
          <FormControl>
            <RadioGroup
              row
              // aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              {console.log("sdafsdafsdfsdfsdfsad", currentStatus, role)}

              {currentStatus != 386 || (AnnouncementStatus && AnnouncementStatus != "" && AnnouncementStatus != "Close") ? (
                <FormControlLabel
                  value="Approve"
                  control={
                    <Radio
                      onChange={(e, v) => {
                        setStatus(e.target.value);
                        setApprove(true);
                        // props.setStatusAction("Approved");
                      }}
                      checked={
                        status && status.trim() == "Approve" ? true : false
                      }
                    // disabled={currentStatus == 353 ? role == "AppointingAuthority" ? false : true : false} 
                    // disabled={ true} 
                    />
                  }
                  // label={`Forward to ${nextStatus?.label}`} //"Approve"
                  label={currentProcessTitle == "Draft" || (currentProcessTitle == "Posted" && AnnouncementStatus && AnnouncementStatus != "") ? `Submit & Forward to ${forwardState?.label}` : `Forward to ${forwardState?.label}`} //"Approve"
                />
              ) : null
              }

              {/* {![employee, reviewer].includes(user) ? ( */}
              {returnState ? (
                <FormControlLabel
                  value="Return"
                  control={
                    <Radio
                      onChange={(e, v) => {
                        setStatus(e.target.value);
                      }}
                      checked={
                        status && status.trim() == "Return" ? true : false
                      }
                      ref={remarkRef}
                    />
                  }
                  label={
                    // currentStatus == 355
                    //   ? `Save Announcement`
                    //   : 
                    returnState?.label ?
                      `Return to ${returnState?.label}`
                      : ""
                  }
                />
              ) : null}
            </RadioGroup>
          </FormControl>
          <TextField
            margin="dense"
            variant="outlined"
            style={{ width: "100%" }}
            size="small"
            label="Remarks"
            multiline={true}
            rows={4}
            InputLabelProps={{
              shrink: true,
            }}
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
            // error={
            //   status == "Return" &&
            //   (currentStatus != 273 || currentStatus == null) &&
            //   remarks == ""
            // }
            error={remarkRef?.current?.childNodes[0].value == status?.trim()}
            className={`flex w-full mx-10 ${remarkRef?.current?.childNodes[0].value == status?.trim()
              ? "hasErrorLbl"
              : ""
              } `}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", marginBottom: "10px" }}>
          <Btn
            attrBtn={{
              color: "primary",
              onClick: () => {
                // if (
                //   status == "Approve" ||
                //   (status == "Return" && remarks) ||
                //   !(
                //     status == "Return" &&
                //     (currentStatus != 273 || currentStatus == null)
                //   )
                // )
                if (remarks != "" || approve || status == "Approve") {
                  handleModleSubmit();
                }
              },
            }}
          >
            {status == "Approve" ? "Click to Approve" : status == "Return" ? "Click to Return" : "Submit"}
          </Btn>
        </DialogActions>
      </Dialog>
      {openConfirmation && (
        <ConfirmModal
          open={openConfirmation}
          setOpen={setOpenConfirmation}
          confimClick={onConfirm}
          cnfrmBtnName="Yes"
          cancelBtnName="No"
          message={"Are you sure to make this change?"}
        />
      )}
    </div>
  );
};
export default AnnouncementStatusChangeModal;
